import React from 'react';
import { Monitor, Briefcase, Users, Landmark, Lightbulb, Building2, GraduationCap, Network } from 'lucide-react';

const sectors = [
  { icon: Monitor, name: 'IT & SaaS' },
  { icon: Briefcase, name: 'Consultancy & Professionele Diensten' },
  { icon: Users, name: 'HR & Recruitment' },
  { icon: Landmark, name: 'Finance & Insurance' },
  { icon: Lightbulb, name: 'Technologie & Innovatie' },
  { icon: Building2, name: 'B2B Services' },
  { icon: GraduationCap, name: "Opleidingscentra's" },
  { icon: Network, name: 'Sectorfederaties' },
];

const SectorFocusSection = () => {
  return (
    <section className="section bg-brand-gray">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Outbound prospectie die werkt in jouw sector</h2>
          <p className="section-subtitle mx-auto">
            We focussen op sectoren waar outbound prospectie bewezen werkt. 15 jaar ervaring, honderden succesvolle projecten.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {sectors.map((sector, index) => (
            <div
              key={index}
              className="flex flex-col items-center p-6 bg-white rounded-lg border border-gray-100 hover:border-brand-blue/30 hover:shadow-md transition-all duration-300 text-center"
            >
              <div className="w-12 h-12 rounded-full bg-brand-lightBlue flex items-center justify-center mb-3">
                <sector.icon className="w-6 h-6 text-brand-blue" />
              </div>
              <span className="text-sm font-medium text-gray-800">{sector.name}</span>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-600 mt-8 text-sm">
          Andere sector? Contacteer ons. We evalueren graag of we een fit zijn.
        </p>
      </div>
    </section>
  );
};

export default SectorFocusSection;
